<template>
  <li class="tasks-layout__task-item">
    <a href="javascript:void(0)" @click="$emit('showTaskDetail')">
      <p class="tasks-layout__task-item-title typo-ignore typo-small-title">
        {{ task.description }}
      </p>
      <p v-if="date" class="tasks-layout__task-item-date typo-ignore typo-tiny">
        {{ date }}
      </p>
    </a>
  </li>
</template>

<script setup>
import { computed } from 'vue';
import { formatDate } from '@/functions/date_format_helpers';
import I18n from 'i18n-js';

const props = defineProps({
  task: { type: Object, required: true },
});
defineEmits(['showTaskDetail']);

const date = computed(() => {
  if (props.task.status === 'incomplete') {
    return props.task.due_date && `${I18n.t('tasks.task_due')} ${formatDate(props.task.due_date)}`;
  } else {
    return props.task.closed_at && `${I18n.t('tasks.task_completed')} ${formatDate(props.task.closed_at)}`;
  }
});
</script>
